import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import FormSection from '../form/FormSection';
import FormHeader from '../form/FormHeader';
import Copy from '../../basics/text/TextCopy';
import suitcss from '../../../helpers/suitcss';
import FieldInput from '../../basics/form/FieldInput';
import MediaImage from '../../basics/media/MediaImage';

import { imageShape } from '../../../propTypes/media';
import imageSizes from '../../../config/imageSizes';

const componentName = 'ActivationFormSimData';

function ActivationFormSimData(props) {
  const { fieldMap, params } = props;
  const { simHeadline, copy, simImage } = params;

  return (
    <div className={suitcss({ componentName })}>
      <Copy utilities={['marginBottom']} raw>{copy}</Copy>
      <FormSection asGrid>
        <FormHeader headline={simHeadline} />
        <Field {...fieldMap.activationCode} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        <div className={suitcss({ utilities: ['col6', 'sHidden'] })} />
        <Field {...fieldMap.msisdn} component={FieldInput} utilities={['col12', 'mlCol6']} withToolTip />
        <div className={suitcss({ componentName, descendantName: 'instructions', utilities: ['col12', 'mlCol6'] })} >
          <MediaImage {...simImage} sizes={imageSizes.activationFormDescription} isLazy />
        </div>
      </FormSection>
    </div>
  );
}

ActivationFormSimData.propTypes = {
  fieldMap: PropTypes.object.isRequired,
  params: PropTypes.shape({
    simHeadline: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    simImage: imageShape.isRequired,
  }),
};

export default ActivationFormSimData;
